// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1713":"424c6f62","4387":"894a1d8b","8946":"424c6f62"}[chunkId] + ".chunk.css";
};